<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :recruit="recruit" />
    </div>
    <div class="content">
      <div class="query">
        <div class="query__header">
          <div class="query__header--text">Transferred Candidates</div>
          <div class="query__header--btn"></div>
        </div>

        <div class="query__body">
          <div class="query__div--content-body-enrol">
            <div class="query__div--content-body-enrol-table">
              <div class="query__div--content-body-table-header">
                <div>Candidate Name</div>
                <div>Role</div>
                <div>Date Transferred</div>
                <div></div>
              </div>
              <div class="query__div--content-body-table-body">
                <div v-show="pageLoading">
                  <div>
                    <PageLoader />
                  </div>
                </div>
                <div v-for="(query, index) in queries" :key="index">
                  <div>
                    <div class="invited_avatar">
                      <img src="./../../../assets/images/leave.png" alt />
                    </div>
                    <!-- <p>Uwem udoh</p> -->
                    <p>{{ query.firstname }} {{ query.lastname }}</p>
                  </div>
                  <!-- <div>Sales Associate</div> -->
                  <div>{{ query.role }}</div>
                  <!-- <div>31/12/2019</div> -->
                  <div>{{ query.transferDate }}</div>
                  <div>
                    <div class="invited_btn">
                      <div>View Profile</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "Tranfer",

  components: {
    Header,
    Sidebar,
    PageLoader,
  },

  data() {
    return {
      item: "transfer",
      recruit: "recruit",
      pageLoading: true,
      queries: [],
    };
  },
  created() {
    this.listTransferredCandidates();
  },
  methods: {
    listTransferredCandidates() {
      this.$http
        .get(`${types.GET_PROFILE}`)
        .then((resp) => {
          this.queries = resp.data.data.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.queries = [];
          this.pageLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    margin-top: 7rem;
    width: 15%;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 4rem;
    background: #fbfafa;
    height: 100vh;

    @media (max-width: 768px) {
      margin-top: 4rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.query {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  .error {
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: left;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
    p {
      margin: 0;
      padding-bottom: 10px;
    }
    p::first-letter {
      text-transform: uppercase;
    }
  }

  .alert {
    padding-top: 30px;
    font-size: 1rem;
    svg {
      margin-right: 7px;
    }
    p {
      margin-bottom: 0;
    }
  }

  .page-loader {
    margin-top: 100px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .query__header {
    overflow: hidden;
    padding-bottom: 5px;

    > .query__header--text {
      width: 500px;
      float: left;
      font-size: 2.083rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .query__header--btn {
      float: right;
      width: 200px;

      > div {
        width: 9.063vw;
        height: 38px;
        border-radius: 2px;
        background-color: #5099de;
        float: right;
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;

        > a {
          color: #ffffff;
          text-decoration: none;
          > div {
            height: 38px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }
      }
    }
  }

  > .query__body {
    border-top: 1px solid #caced5;
    padding: 20px 5px 0 5px;

    > .query__div--content-body-enrol {
      margin-bottom: 50px;
      > p {
        font-size: 1.458rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-bottom: 50px;
      }

      .query__div--content-body-enrol-filter {
        overflow: hidden;
        > .query__div--content-body-filter-left {
          width: 120px;
          height: 35px;
          border-radius: 2px;
          border: solid 1px #caced5;
          background-color: #ffffff;
          float: left;
          margin-right: 20px;
          font-size: 0.833rem;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #777777;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }

        > .query__div--content-body-filter-right {
          width: 200px;
          height: 35px;
          border-radius: 2px;
          background-color: #ffffff;
          float: left;
        }
      }

      > .query__div--content-body-enrol-table {
        margin-top: 30px;
        > .query__div--content-body-table-header {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > div {
            width: 25%;
            text-align: center;
            font-size: 1.042rem;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #000000;
          }
        }

        .query__div--content-body-table-body {
          border-top: 5px solid #5099de;
          margin-top: 20px;
          padding-top: 20px;

          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            height: 76px;
            margin-bottom: 20px;
            background-color: #ffffff;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            cursor: pointer;

            > div {
              width: 25%;
              text-align: center;
              font-size: 1.042rem;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #000000;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              padding: 0 20px;

              > .invited_avatar {
                width: 50px;
                height: 50px;
                border-radius: 60px;
                overflow: hidden;
                background-color: #ccc;
              }

              > p {
                width: calc(100% - 50px);
                text-align: left;
                padding-left: 10px;
                margin: 0;
              }

              > .invited_btn {
                max-width: 150px;
                height: 40px;
                border-radius: 2px;
                border: solid 1px #5099de;
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: center;
                margin: auto;
                cursor: pointer;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
              }
            }
          }
        }
      }
    }

    > .query__div--content-body-paginate {
      border: 1px solid red;
      width: 20.833vw;
      margin: auto;
      height: 40px;
      border-radius: 4px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      border: solid 1px #d7dae2;
      background-color: #ffffff;
      margin-bottom: 150px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;

      > .query__div--content-body-paginate-prev {
        width: 20%;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }

      > .query__div--content-body-paginate-page {
        width: 60%;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;

        > div {
          width: 20%;
          height: 40px;
          border: solid 1px #d7dae2;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }

      > .query__div--content-body-paginate-next {
        width: 20%;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 52px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }
  }
}
</style>
